import { Container } from "@mui/material";
import image1 from "../../assets/home3.png";
import home from "../../assets/home33.png";
import Footer from "../../components/footer/footer";
import TopSellerPlants from "../../components/home/top-sellers";
import './home.css'
import AboutUSDesktop from "../about/AboutDesktop";
import AboutUSMobile from "../about/AboutUSMobile";
import HomeSlugMobile from "../../components/home/home-slug/HomeSlugMobile";
import HomeSlugDesktop from "../../components/home/home-slug/HomeSlugDesktop";
import HomeCategoriesDesktop from "../../components/home/home-categories/homeCategoriesDesktop";
import HomeCategoriesMobile from "../../components/home/home-categories/homeCategoriesMobile";
import BestSellerPlants from "../../components/home/best-seller/best-seller";
import WhyChooseUs from "../../components/home/choose-us/choose-us";
const Home = ({ isMobile }: { isMobile: boolean }) => {

  return (
    <>

      {isMobile ? <HomeSlugMobile /> : <HomeSlugDesktop />}
      {isMobile ? <AboutUSMobile /> : <AboutUSDesktop />}
      {isMobile ? <HomeCategoriesMobile /> : <HomeCategoriesDesktop />}






      <TopSellerPlants />
      <BestSellerPlants />
      <WhyChooseUs />
      <Footer />

    </>
  );
};

export default Home;



